import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Chip,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  Icon,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useSelector } from 'react-redux';


const defaultCustomerGroups = [
  {
    id: 1,
    code: 'General'
  }
];

const FilterDrawer = (
  {setOpenFilter, setFilterConditions, filterConditions}: IFilterDrawerProps
) => {
  const [expandedName, toggleExpandedName] = useState(false);
  const [expandedEmail, toggleExpandedEmail] = useState(false);
  const [expandedAddress, toggleExpandedAddress] = useState(false);
  const [expandedPhone, toggleExpandedPhone] = useState(false);
  const [expandedGroup, toggleExpandedGroup] = useState(false);
  const [conditions, setConditions] = useState({
    name: {
      field: 'name',
      value: filterConditions.name?.value || '',
      conditionType: 'like'
    },
    email: {
      field: 'email',
      value: filterConditions.email?.value || '',
      conditionType: 'like'
    },
    billing_full: {
      field: 'billing_full',
      value: filterConditions.billing_full?.value || '',
      conditionType: 'like'
    },
    billing_telephone: {
      field: 'billing_telephone',
      value: filterConditions.billing_telephone?.value || '',
      conditionType: 'like'
    },
    group_id: {
      field: 'group_id',
      value: filterConditions.group_id?.value || '',
      conditionType: 'in'
    }
  });

  const { customerGroups } = useSelector(
    (state: {customers: ICustomersState}) => state.customers
  );

  const handleChangeFilter = (field, value, conditionType, name) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: {
          field,
          value,
          conditionType
        }
      }
    ));
  };

  const handleApplyFilter = () => {
    setFilterConditions(conditions);
    setOpenFilter(false);
  };

  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="flex items-center flex-wrap mb-2">
          {Object.values(conditions).map((filterItem, index) => {
            if (!filterItem.value) {
              return null;
            }

            const label = filterItem.value.replace(/%/g, '');
            const fieldName = filterItem.field;

            if (filterItem.field === 'group_id') {
              const groupsIdsSelected = filterItem.value.length ? filterItem.value.split(',') : [];

              return (
                <>
                  {groupsIdsSelected.map((groupId) => {
                    const code = [...defaultCustomerGroups, ...customerGroups]
                      .find((group) => group.id == groupId)?.code;

                    if (!code) {
                      return null;
                    }

                    return (
                      <div key={`filter-group-${groupId}`} className="mr-2 mb-2">
                        <Chip
                          label={code}
                          onDelete={() => {
                            setConditions({
                              ...conditions,
                              group_id: {
                                ...conditions.group_id,
                                value: groupsIdsSelected.filter((id) => id != groupId).join(',')
                              }
                            }
                            );
                          }}
                        />
                      </div>
                    );
                  })
                  }
                </>
              );
            }


            return (
              <div key={`filter-${index}`} className="mr-2 mb-2">
                <Chip
                  label={label}
                  onDelete={() => {
                    setConditions({
                      ...conditions,
                      [fieldName]: {
                        ...conditions[fieldName],
                        value: ''
                      }
                    });
                  }}
                />
              </div>
            );
          })}
        </div>
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedName((expandedName) => !expandedName)}
        >
          <Typography variant="h6">Customer Name</Typography>
          {expandedName ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedName} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="name"
            label="Customer Name"
            value={conditions.name.value.replace(/%/g, '')}
            onChange={(event) => {
              const {name, value} = event.target;
              handleChangeFilter(name, `%${value}%`, 'like', name);
            }}
          />
        </Collapse>
        <Divider className="my-5" />
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedEmail((expandedEmail) => !expandedEmail)}
        >
          <Typography variant="h6">Customer Email</Typography>
          {expandedEmail ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedEmail} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="email"
            label="Customer Email"
            value={conditions.email.value.replace(/%/g, '')}
            onChange={(event) => {
              const {name, value} = event.target;
              handleChangeFilter(name, `%${value}%`, 'like', name);
            }}
          />
        </Collapse>
        <Divider className="my-5" />
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedAddress((expandedAddress) => !expandedAddress)}
        >
          <Typography variant="h6">Customer Billing Address</Typography>
          {expandedAddress ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedAddress} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="billing_full"
            label="Customer Billing Address"
            value={conditions.billing_full.value.replace(/%/g, '')}
            onChange={(event) => {
              const {name, value} = event.target;
              handleChangeFilter(name, `%${value}%`, 'like', name);
            }}
          />
        </Collapse>
        <Divider className="my-5" />
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedPhone((expandedPhone) => !expandedPhone)}
        >
          <Typography variant="h6">Customer Phone</Typography>
          {expandedPhone ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedPhone} timeout="auto">
          <TextField
            fullWidth
            variant="outlined"
            className="my-5"
            name="billing_telephone"
            label="Customer Phone"
            value={conditions.billing_telephone.value.replace(/%/g, '')}
            onChange={(event) => {
              const {name, value} = event.target;
              handleChangeFilter(name, `%${value}%`, 'like', name);
            }}
          />
        </Collapse>
        <Divider className="my-5" />
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedGroup((expandedGroup) => !expandedGroup)}
        >
          <Typography variant="h6">Customer Group</Typography>
          {expandedGroup ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedGroup} timeout="auto">
          <FormControl component="div">
            {[...defaultCustomerGroups, ...customerGroups].map((group) => (
              <FormControlLabel
                key={`customer-group-${group.id}`}
                value={group.id}
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={conditions.group_id.value.split(',').some((value) => +value === group.id)}
                    onChange={({target: {checked}}) => {
                      const groupIdsSelected = conditions.group_id.value.length
                        ? conditions.group_id.value.split(',')
                        : [];

                      const value = checked
                        ? [...groupIdsSelected, group.id].join(',')
                        : groupIdsSelected.filter((id) => id != group.id).join(',');

                      handleChangeFilter('group_id', value, 'in', 'group_id');
                    }}
                  />
                }
                label={group.code}
              />
            ))}
          </FormControl>
        </Collapse>
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default FilterDrawer;
